<!--
 * @Author: zhujuan
 * @Date: 2022-01-18 17:57:58
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-02-16 15:10:43
 * @Description: 
 * @FilePath: /nqc-pc-ui/src/common/components/PopoverNurse/index.vue
-->
<template>
  <div>
    <w-popover
      ref="popover"
      trigger="click"
      :visible-arrow="false"
      :open-delay="0"
      :close-delay="0"
      popper-class="padd0 w_popover_container"
      :disabled="disabled"
      @hidden="cancel"
    >
      <div v-if="isShow && !disabled" class="popover-warp">
        <i class="icon-close w-icon-close" @click="cancel"></i>
        <div class="popover-warp-body">
          <AddNurse ref="addPerson" :key-names="keyNames" :row="row"></AddNurse>
        </div>

        <div class="popover-footer">
          <div class="popover-footer--right">
            <w-button @click="cancel">取消</w-button>
            <w-button type="primary" @click="confirm">确认</w-button>
          </div>
        </div>
      </div>
      <template slot="reference">
        <div @click="show">
          <w-tooltip
            :disabled="isTip"
            :content="value"
            placement="top-start"
            theme="dark"
          >
            <img
              slot="reference"
              class="pic-people left"
              src="@/common/assets/images/addpeople.png"
              alt="添加患者"
            />
          </w-tooltip>
        </div>
      </template>
    </w-popover>
  </div>
</template>

<script>
import AddNurse from './module/AddNurse'
export default {
  name: 'PopoverInput',
  components: { AddNurse },
  props: {
    //整行对象
    row: {
      type: Object,
      default: () => {}
    },

    valueKey: {
      //id
      type: String,
      default: ''
    },
    labelKey: {
      //input反显label值
      type: String,
      default: ''
    },
    // 表格行 单框默认0
    index: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShow: false,
      detail: {},
      isEdit: false
    }
  },

  computed: {
    value() {
      return this.row[this.labelKey] ? this.row[this.labelKey].join(',') : ''
    },
    keyNames() {
      return {
        values: this.valueKey,
        labels: this.labelKey
      }
    },
    isTip() {
      if (!this.value || this.value.length < 10) {
        return true
      } else {
        return false
      }
    }
  },

  mounted() {},
  created() {},
  methods: {
    show() {
      this.isShow = true
    },
    changeValue(val) {
      this.$emit('changeValue', val, this.index)
    },

    //确认 按钮提交
    confirm() {
      this.detail = this.$refs.addPerson.getPersonName()
      this.$emit('changeValue', this.detail, this.index)
      this.cancel()
    },
    //取消
    cancel() {
      this.isShow = false
      this.$refs['popover'].showPopper = false
    }
  }
}
</script>
<style lang="scss" scoped>
.pic-people {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
</style>
